import {
  SlTree
} from "./chunk.MSDIZVRW.js";

// src/components/tree/tree.ts
var tree_default = SlTree;
SlTree.define("sl-tree");

export {
  tree_default
};
